import React, { useEffect, useState } from "react";
import { IoPersonAddOutline } from "react-icons/io5";

const VisitCardButton = () => {
  const [isIOS, setIsIOS] = useState(false);
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setIsIOS(true);
    }
  }, []);

  const handleClick = (e) => {
    if (isIOS) {
      e.preventDefault();
      setShowTip(true);
      window.open("/youka.vcf", "_blank");
      setTimeout(() => setShowTip(false), 6000);
    }
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {showTip && (
        <div className="absolute bottom-20 right-1 bg-white text-[#103d5b] text-sm shadow-xl rounded-xl px-4 py-3 border border-[#103d5b]/20 w-[260px] animate-fadeIn">
          <div className="relative">
            📱 Tippen Sie auf <strong>„Teilen“</strong> → 
            <strong> „Zu Kontakten hinzufügen“</strong>
            <div className="absolute -bottom-2 right-6 w-3 h-3 bg-white border-b border-r border-[#103d5b]/20 rotate-45"></div>
          </div>
        </div>
      )}

      <a
        href="/youka.vcf"
        download={!isIOS ? "YOUKA_GmbH.vcf" : undefined}
        onClick={handleClick}
        className="flex items-center justify-center bg-[#103d5b] text-[#d7eaf1] p-4 rounded-full shadow-lg hover:bg-[#d7eaf1] hover:text-[#103d5b] transition duration-300 relative"
        title="Kontaktdaten auf dem Gerät speichern!"
      >
        <IoPersonAddOutline className="text-3xl leading-none" />
      </a>
    </div>
  );
};

export default VisitCardButton;
